import { effect, inject } from '@angular/core'
import { provideAppInitializer } from '@angular/core'

import { SocketService } from './socket.service'
import { AUTH_STORE } from '../tokens/auth-store.token'

/**
 * Provides a factory function to initialize the socket connection during the application startup.
 *
 * This function uses the `provideAppInitializer` utility to set up an application initializer
 * that ensures the `SocketService` is initialized with a valid authentication token from the `AuthStore`.
 *
 * The initializer observes the authentication token and initializes the socket connection
 * when a valid token is available. It ensures that the socket is initialized only once.
 *
 * @returns A function that sets up the socket initialization logic during app startup.
 */
export const provideSocketInitializer = () => {
  return provideAppInitializer(() => {
    const authStore = inject(AUTH_STORE)
    const socketService = inject(SocketService)

    let initialized = false

    effect(() => {
      const token = authStore.token()
      if (token && !initialized && !socketService.socket?.connected) {
        socketService.init(token)
        initialized = true
      }
    })

    return
  })
}
